var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 .334A4.663 4.663 0 0 0 .333 5.001c0 1.16.334 2.246.94 3.226.634 1.027 1.467 1.907 2.107 2.934.313.5.54.966.78 1.506.173.367.313 1 .84 1s.667-.633.833-1c.247-.54.467-1.006.78-1.506.64-1.02 1.474-1.9 2.107-2.934.614-.98.947-2.066.947-3.226A4.663 4.663 0 0 0 5 .334m0 6.5a1.667 1.667 0 1 1 .001-3.335 1.667 1.667 0 0 1 0 3.335"
  })));
};
export default SvgLocation;